export const CAMANCHACA_SSO_TENANT_ID = '68b6208c85a6a0f2b2a70980';

export const CAMANCHACA_ACCIDENTES_PERFILAMIENTO: Record<string, string[]> = {
  //'contacto@planiwise.com': ['CRUSTASUR'],
  //'ckroeger@stemwaste.cl': ['PESCA NORTE', 'FARMING PUERTO MONTT'],
  //"phernandez@camanchaca.cl":"Todo",
  'gfernandez@camanchaca.cl': ['PESCA NORTE', 'PESCA SUR'],
  'manuel.arriagada@camanchaca.cl': ['FARMING PUERTO MONTT', 'PROCESOS SAN JOSÉ', 'PROCESOS TOMÉ'],
  'nguzman@camanchaca.cl': ['CULTIVOS'],
  'rafael.ortega@camanchaca.cl': ['CULTIVOS'],
  'nicolas.pizarro@camanchaca.cl': ['PESCA NORTE', 'PESCA SUR'],
  'lseguel@camanchaca.cl': ['PESCA NORTE'],
  'aflores@camanchaca.cl': ['PELÁGICO'],
  'aramirez@camanchaca.cl': ['CRUSTASUR'],
  'msanmartin@camanchaca.cl': ['PROCESOS SAN JOSÉ', 'PROCESOS TOMÉ'],
  'ncanete@camanchaca.cl': ['FARMING PUERTO MONTT'],
};
// 0	"CRUSTASUR"
// 1	"CULTIVOS"
// 2	"FARMING PUERTO MONTT"
// 3	"PELÁGICO"
// 4	"PESCA NORTE"
// 5	"PESCA SUR"
// 6	"PROCESOS SAN JOSÉ"
// 7	"PROCESOS TOMÉ"
// 8	"ROCUANT TALCAHUANO"

export const CAMANCHACA_ACCIDENTES_DASHBOARD_LINKS = [
  {
    slug: 'corporativo-sso',
    name: 'Corporativo SSO',
    description: 'Reporte Corporativo Camanchaca SSO',
    img: 'https://i.ibb.co/MkrGdcF1/Captura-de-pantalla-2026-07-22-a-la-s-13-18-36.png',
    link: 'https://app.powerbi.com/reportEmbed?reportId=f0ad90b4-97a1-425d-a098-feb81f89a98e',
  },
];

export const CAMANCHACA_ACCIDENTES_FILTERS: Record<string, {table: string; column: string}> = {
  'f0ad90b4-97a1-425d-a098-feb81f89a98e': {table: 'dim_estructura', column: 'virtual_area2'},
};

export const isCamanchacaSsoTenant = (tenantId?: string | null): boolean => tenantId === CAMANCHACA_SSO_TENANT_ID;

export const getCamanchacaAccidentesAreas = (email?: string | null, tenantId?: string | null): string[] | undefined => {
  if (!isCamanchacaSsoTenant(tenantId) || !email) {
    return undefined;
  }
  return CAMANCHACA_ACCIDENTES_PERFILAMIENTO[email.toLowerCase()];
};

export const injectCamanchacaAccidentesDashboardLinks = (
  email: string | undefined | null,
  dashboardLinks: any[],
  tenantId?: string | null,
) => {
  const areas = getCamanchacaAccidentesAreas(email, tenantId);
  if (!Array.isArray(areas)) {
    return dashboardLinks;
  }

  const hasExistingLink = dashboardLinks?.some((dashboardLink) => dashboardLink?.link);
  return hasExistingLink
    ? [...dashboardLinks, ...CAMANCHACA_ACCIDENTES_DASHBOARD_LINKS]
    : [...CAMANCHACA_ACCIDENTES_DASHBOARD_LINKS];
};
